<div class="frame">
  <div style="display: flex; flex-direction: column;">
    <div style="display: flex; justify-content: space-between;">
      <div style="display: flex; flex-direction: column; justify-content: center; flex-basis: 50%;">
        <ul class="link-list">
          <li class="footer-link" (click)="onNavigate('team')">Team</li>
          <li class="footer-link" (click)="onNavigate('products')">Services</li>
          <li class="footer-link" (click)="onNavigate('gallery')">Gallery</li>
          <li class="footer-link" (click)="onNavigate('about')">About</li>
          <li class="footer-link" (click)="onNavigate('hours')">Hours</li>
          <hr>
        </ul>

        <ul class="link-col">
          <li class="other-link" (click)="onNavigate('team')">Team</li>
          <li class="other-link" (click)="onNavigate('products')">Services</li>
          <li class="other-link" (click)="onNavigate('gallery')">Gallery</li>
          <li class="other-link" (click)="onNavigate('about')">About</li>
          <li class="other-link" (click)="onNavigate('hours')">Hours</li>
        </ul>
      </div>
      <div class="center-logo">
        <img src="../../assets/media/logo_lg.png" height="150" width="150" loading="lazy" alt="Barbershop Denim logo">
        <p style="font-size: small; white-space: nowrap;">&copy; {{year}} Barbershop Denim™</p>
      </div>
      <div
        style="display: flex; flex-direction: column; align-items: flex-end; justify-content: center; flex-basis: 50%;">
        <div class="book-button" (click)="onBook()">
          <h3 style="white-space: nowrap;">Make an appointment</h3>
        </div>

        <div class="icon-list">
          <i class="fab fa-instagram fa-3x" style="cursor: pointer;" (click)="onInsta()"></i>
          <i class="fab fa-yelp fa-3x" style="cursor: pointer;" (click)="onYelp()"></i>
          <i class="far fa-envelope fa-3x" style="cursor: pointer;" (click)="onEmail()"></i>
        </div>
      </div>
    </div>

    <div class="lower-logo">
      <img src="../../assets/media/logo_lg.png" height="150" width="150" loading="lazy" alt="Barbershop Denim logo">
      <p style="font-size: small; white-space: nowrap;">&copy; {{year}} Barbershop Denim™</p>
    </div>

  </div>
</div>
